"use client";

import { SeriesModel } from "@api/models";
import { ChargeBox } from "app/components/ChargeBox";
import ContentElement from "app/components/ContentElement";
import { ContentElementRead } from "app/components/ContentElementRead";
import { useEpisode } from "app/hooks";
import { Suspense } from "react";

export function ChargeBoxOrViewer({
  episodeId,
  series,
}: {
  episodeId: string;
  series?: SeriesModel;
}) {
  const { results, isLoading, error } = useEpisode(episodeId);
  if (isLoading) {
    return <p className="ep-loading">&nbsp;</p>;
  } else {
    const episode = results.episode;
    const isViewer = episode.content && episode.content[0] && episode.content[0].viewerId;
    if (episode.access && episode.access.hasAccess) {
      return (
        <div className={"ep-main-content " + (isViewer ? "mode-viewer" : "mode-column")}>
          {episode?.content?.map((element, index) => (
            <ContentElement
              element={{
                ...element,
                episode: episode,
              }}
              key={index}
            />
          ))}
          {/* 既読情報送信 */}
          <ContentElementRead
            episodeId={episodeId}
            seriesIndexId={episode.series.indexId}
            seriesHash={episode.series.id}
          />
        </div>
      );
    } else {
      return (
        <div className="ep-main-content mode-charge">
          <Suspense>
            <ChargeBox episode={episode} series={series} />
          </Suspense>
        </div>
      );
    }
  }
}
